import withHasPermission from '../../hoc/withHasPermission';
import { Permission } from '../../permissions/permission';
import Servers from './Servers';

const ServersView = withHasPermission(() => {
    return <Servers title={'Servers'} icon={'fa-server'} />;
}, Permission.Root_Servers);

export default ServersView;
